import { core_v1_DataSource } from '@antimatterhq/asl-api-ts-v1';
import { sourceHasUnsavedChanges } from './source';
import { gettingStartedHasUnsavedChanges } from './gettingStarted';
import { bronzeHasUnsavedChanges } from './bronze';
import { preTransformHasUnsavedChanges } from './preTransform';
import { silverHasUnsavedChanges } from './silver';
import { goldHasUnsavedChanges } from './gold';
import { getUnpublishedChanges } from './uiStatus';

export const hasUnsavedChanges = (datasource: core_v1_DataSource) => {
  const unsavedDatasource = getUnpublishedChanges(datasource);
  if (!unsavedDatasource) {
    return false;
  }
  return (
    sourceHasUnsavedChanges(datasource, unsavedDatasource) ||
    gettingStartedHasUnsavedChanges(datasource, unsavedDatasource) ||
    bronzeHasUnsavedChanges(datasource, unsavedDatasource) ||
    preTransformHasUnsavedChanges(datasource, unsavedDatasource) ||
    silverHasUnsavedChanges(datasource, unsavedDatasource) ||
    goldHasUnsavedChanges(datasource, unsavedDatasource)
  );
};
